// @flow
// This file is generated by make-version-metadata.js script
// Don't import this file directly, prefer to use newIDE/app/src/Version/index.js instead.
// prettier-ignore
module.exports = {
  "version": "5.5.232",
  "gitHash": "a4c2778b8db4334688da3ef420316d3bc82d4b97",
  "versionWithHash": "5.5.232-a4c2778b8db4334688da3ef420316d3bc82d4b97"
};
